import React from 'react';
import { motion } from 'framer-motion';

const Terms: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-purple-800 to-teal-700 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center text-white"
          >
            <h1 className="text-4xl font-bold mb-4">Terms of Service</h1>
            <p className="text-xl text-purple-100 max-w-3xl mx-auto">
              Please read these terms carefully before using our services.
            </p>
          </motion.div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="prose prose-lg max-w-none">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
          >
            <section className="mb-12">
              <h2>1. Acceptance of Terms</h2>
              <p>
                By accessing or using Pincode Pro's services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
              </p>
            </section>

            <section className="mb-12">
              <h2>2. Service Description</h2>
              <p>
                Pincode Pro provides postal code lookup and verification services for Indian addresses. Our services include:
              </p>
              <ul>
                <li>PIN code search and validation</li>
                <li>Post office location information</li>
                <li>Address formatting guidelines</li>
                <li>API access for business integration</li>
              </ul>
            </section>

            <section className="mb-12">
              <h2>3. User Obligations</h2>
              <p>When using our services, you agree to:</p>
              <ul>
                <li>Provide accurate and complete information</li>
                <li>Use the service for lawful purposes only</li>
                <li>Not attempt to circumvent any access restrictions</li>
                <li>Not interfere with the proper operation of the service</li>
                <li>Maintain the security of your account credentials</li>
              </ul>
            </section>

            <section className="mb-12">
              <h2>4. API Usage Terms</h2>
              <p>For users accessing our API:</p>
              <ul>
                <li>API keys are non-transferable</li>
                <li>Usage is subject to rate limits and quotas</li>
                <li>Data must be used in accordance with our guidelines</li>
                <li>Caching of results must follow our caching policy</li>
                <li>Attribution requirements must be followed</li>
              </ul>
            </section>

            <section className="mb-12">
              <h2>5. Data Usage</h2>
              <p>
                Our postal data is sourced from India Post and is updated regularly. While we strive for accuracy, we cannot guarantee the completeness or timeliness of all information.
              </p>
            </section>

            <section className="mb-12">
              <h2>6. Intellectual Property</h2>
              <p>
                All content, features, and functionality of Pincode Pro, including but not limited to text, graphics, logos, and software, are owned by or licensed to us and are protected by copyright and other intellectual property laws.
              </p>
            </section>

            <section className="mb-12">
              <h2>7. Privacy and Data Protection</h2>
              <p>
                Your use of our services is also governed by our Privacy Policy. Please review our Privacy Policy to understand how we collect, use, and protect your data.
              </p>
            </section>

            <section className="mb-12">
              <h2>8. Limitation of Liability</h2>
              <p>
                Pincode Pro provides its services "as is" and makes no warranties, express or implied. We shall not be liable for any indirect, incidental, special, consequential, or punitive damages.
              </p>
            </section>

            <section className="mb-12">
              <h2>9. Service Modifications</h2>
              <p>
                We reserve the right to modify, suspend, or discontinue any part of our service at any time. We will provide notice of significant changes when possible.
              </p>
            </section>

            <section className="mb-12">
              <h2>10. Termination</h2>
              <p>
                We may terminate or suspend your access to our services immediately, without prior notice, for conduct that we believe violates these Terms or is harmful to other users, us, or third parties.
              </p>
            </section>

            <section className="mb-12">
              <h2>11. Governing Law</h2>
              <p>
                These terms shall be governed by and construed in accordance with the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in Bangalore, Karnataka.
              </p>
            </section>

            <section className="mb-12">
              <h2>12. Contact Information</h2>
              <p>
                For any questions about these Terms of Service, please contact us at:
              </p>
              <ul>
                <li>Email: contact@pincodeindia.tag360.in</li>
                <li>Phone: NA</li>
                <li>Address: New Delhi, India</li>
              </ul>
            </section>
          </motion.div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600">
            Last updated: January 6, 2025
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;
